import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import '../styles/createproject.css'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import UserSearch from '../components/UserSearch'
import { getTeam } from '../services/graphql'
import { getUser } from '../utils/util'

const CreateTeam = (props) => {
  const location = useLocation()
  const [team, setTeam] = useState({})

  useEffect(() => {
    const params = location.search.split('=')
    const id = params[params.length - 1]
    if (id) {
      getTeam(id)
        .then((r) => {
          const team = r.data.getTeam
          setTeam(team)
        })
        .catch((e) => console.log(e))
    }
  }, [])

  return (
    <div className="create-container">
      <Paper elevation={0} style={{ marginLeft: '10%' }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href="/teams" to="/teams">
            Teams
          </Link>
          <Typography color="textPrimary">{team.name}</Typography>
        </Breadcrumbs>
      </Paper>
      <Grid container className="create-grid">
        <Grid item xs={8} className="project-item">
          <Typography variant="h4">Your Team</Typography>
          {team && (
            <form noValidate autoComplete="off">
              <Typography variant="h5">{team.name}</Typography>
              <Typography style={{ marginTop: '10px', textAlign: 'left' }} variant="h5">
                Search for members
              </Typography>
              <UserSearch
                {...props}
                team={team}
                notDelete={!team.user && team.user && getUser().id !== team.user.id}
              />
            </form>
          )}
        </Grid>
      </Grid>
    </div>
  )
}

export default CreateTeam
